import { render, staticRenderFns } from "./addDynamicMen.vue?vue&type=template&id=bacf7a74&scoped=true&"
import script from "./addDynamicMen.vue?vue&type=script&lang=js&"
export * from "./addDynamicMen.vue?vue&type=script&lang=js&"
import style0 from "./addDynamicMen.vue?vue&type=style&index=0&id=bacf7a74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bacf7a74",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bacf7a74')) {
      api.createRecord('bacf7a74', component.options)
    } else {
      api.reload('bacf7a74', component.options)
    }
    module.hot.accept("./addDynamicMen.vue?vue&type=template&id=bacf7a74&scoped=true&", function () {
      api.rerender('bacf7a74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/famousPerson/dynamicMent/components/addDynamicMen.vue"
export default component.exports